import React, { useContext, useEffect } from "react";
import { Button } from "react-bootstrap";
import "./formTerms.scss";
import { DataContext } from "../../js/App";

const FormTerms = () => {
  const context = useContext(DataContext);
  const { setTermsAccepted, setActiveTab, startDescription } = context;

  const handleAcceptTerms = () => {
    setTermsAccepted(true);
    setActiveTab("claimant");
  };
  return (
    <>
      <h2>Before you begin</h2>
      <div className="startDescription" dangerouslySetInnerHTML={{ __html: startDescription }}>      
      </div>
      <hr />
      <div className="agreeButtonContainer">
        <Button onClick={() => handleAcceptTerms()} variant="primary">
          I agree
        </Button>
      </div>
    </>
  );
};

export default FormTerms;
